export default "__VITE_ASSET__DTuMPObQ__"